export const blogMeta = (post) => ({
  title: post.titulo,
  link: [
    {
      rel:"preload",
      as:"image",
      href: "https://ik.imagekit.io/cyrcl27sn" + post.imagem 
    },
    {
      rel:"canonical",
      href: "https://multiversa.com/blog/" + post.slug + '/',
    },
  ],
  meta: [
    {
      hid: "https://multiversa.com/blog/" + post.slug + '/',
      name:post.titulo,
      content:post.description_seo,
      keywords: post.meta_tags ? post.meta_tags : "educacao, multiversa"
    },
    {
      name:"thumbnail",
      content:"https://ik.imagekit.io/cyrcl27sn" + post.imagem 
    },
    {name:"type", content:"article"},
    {property:"fb:app_id", hid:"fb:app_id", name:"fb:app_id", content:"390367489652187" },
    {property:"og:title", hid: "og:title", name:"og:title", content:post.titulo },
    {property:"og:description", hid: "og:description", name:"og:description", content:post.description_seo },
    {property:"og:site_name", hid: "og:site_name", name:"og:site_name", content:"Multiversa"},
    {property:"og:type", hid:"og:type", name:"type", content:"article"},
    { property:"og:image", hid: "og:image", itemprop:"image", name:"og:image", content:"https://ik.imagekit.io/cyrcl27sn" + post.imagem },
    { property:"og:image:secure_url", hid: "og:image:secure_url", itemprop:"image", name:"og:image:secure_url", content:"https://ik.imagekit.io/cyrcl27sn" + post.imagem },
    {property: "og:image:type", hid: "og:image:type", name: "og:image:type", content: post.imagem.split('.')[1] },
    { property: "og:url", hid: "og:url", name: "og:url", content: "https://multiversa.br/blog/" + post.slug + '/' },
    
    
    {property:"twitter:card", hid: "twitter:card", name:"twitter:card",  content:"summary_large_image" },
    {property:"twitter:title", hid: "twitter:title", name:"twitter:title", content:post.titulo  },
    {property:"twitter:description", hid: "twitter:description", name:"twitter:description", content:post.description_seo },
    
    {name:"robots", content:"index,follow"}
  ]
})
